'use client';

import React from "react";
import {
  LayoutDashboard, Users, Coffee, Wrench, Box, Briefcase, Settings, MessageCircleQuestion,
} from "lucide-react";
import { OperatorDesktop } from "./OperatorDesktop";

// A MOCK of the Kreta host shell so reviewers can see what "Jigyasa inside
// Kreta" will look like (embedding locked in Round-trip 4, 11 Jun 2026).
// Only the content area is real Jigyasa; the sidebar imitates Kreta and is
// NOT part of the handed-over package.
const NAV = [
  { label: "Dashboard", icon: LayoutDashboard },
  { label: "Hubs & Team", icon: Users },
  { label: "Co-working", icon: Coffee },
  { label: "Service Desk", icon: Wrench },
  { label: "Assets", icon: Box },
  { label: "CRM", icon: Briefcase },
  { label: "Enquiries", icon: MessageCircleQuestion, active: true },
  { label: "Settings", icon: Settings },
];

export const KretaFrame = () => (
  <div>
    <div
      data-testid="kreta-preview-note"
      className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-900"
    >
      <strong>Embedded preview.</strong> This is how Jigyasa will appear inside Kreta as the
      &ldquo;Enquiries&rdquo; module — same login, same left menu, no separate app. The sidebar here is a
      mock-up of Kreta; only the content area is Jigyasa.
    </div>
    <div className="flex min-h-[70vh]">
      <aside
        data-testid="kreta-mock-sidebar"
        className="hidden w-60 shrink-0 flex-col border-r border-zinc-200 bg-white md:flex"
      >
        <div className="border-b border-zinc-100 px-5 py-5">
          <div className="text-base font-bold tracking-tight text-zinc-900">Wekreate Space</div>
          <div className="mt-0.5 text-[11px] uppercase tracking-wider text-zinc-400">Powered by Kreta</div>
          <div className="mt-3 text-xs text-zinc-600">
            Enquiries Operator · <span className="text-zinc-400">Staff</span>
          </div>
          <div className="mt-1 inline-flex items-center rounded-full bg-violet-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-violet-800">
            Enquiries · org-wide
          </div>
        </div>
        <nav className="flex-1 space-y-1 px-3 py-4">
          {NAV.map(({ label, icon: Icon, active }) => (
            <div
              key={label}
              data-testid={`kreta-nav-${label.replace(/\s+|&/g, "-").toLowerCase()}`}
              className={`flex items-center gap-3 rounded-lg px-3 py-2 text-sm ${
                active ? "bg-zinc-900 font-semibold text-white" : "text-zinc-600"
              }`}
            >
              <Icon size={16} /> {label}
            </div>
          ))}
        </nav>
        <div className="border-t border-zinc-100 px-5 py-3 text-[11px] text-zinc-400">
          Mock host shell — not part of Jigyasa
        </div>
      </aside>
      <main className="min-w-0 flex-1 bg-zinc-50">
        <OperatorDesktop />
      </main>
    </div>
  </div>
);
